/**
 * Shared helpers for telemetry event attributes (Track C).
 *
 * Kept small and side-effect-free so they can be used from any component
 * without coupling to the SDK instance.
 */

/** Map a monetary amount to the telemetry price/amount band enum. */
export function toBand(amount: number): string {
  if (Number.isFinite(amount) && amount > 0) {
    if (amount <= 50) return '$0-50';
    if (amount <= 100) return '$50-100';
    if (amount <= 200) return '$100-200';
    if (amount <= 500) return '$200-500';
    return '$500+';
  }
  return '$0-50';
}

/**
 * Best-effort `service.viewed` entrySource, derived from the previous page in
 * this SPA (document.referrer). External/direct loads resolve to direct-link.
 */
export function resolveServiceEntrySource(): string {
  try {
    const ref = document.referrer;
    if (!ref) return 'direct-link';
    const url = new URL(ref);
    if (url.hostname !== window.location.hostname) return 'direct-link';
    const path = url.pathname;
    if (path.startsWith('/services/search-list')) return 'search';
    if (path.startsWith('/home')) return 'home-featured';
    if (path.startsWith('/services/service-details')) return 'related-service';
    return 'direct-link';
  } catch {
    return 'direct-link';
  }
}

/**
 * `booking.started` entrySource from the page the "Book Now" CTA sits on.
 */
export function resolveBookingEntrySource(currentPath: string): string {
  if (currentPath.startsWith('/services/search-list')) return 'search-results';
  if (currentPath.startsWith('/home')) return 'home';
  if (currentPath.startsWith('/services/service-details'))
    return 'service-detail';
  return 'direct-link';
}
